import { scroller } from "@/core/resource";
import eventTypes from "@/events/event-types";
import store from "@/store";
import types from "@/store/types";
import { Sine, TweenLite } from "gsap";
var GoToTop = /** @class */ (function () {
    function GoToTop(el) {
        console.log("[create] GoToTop");
        this._el = el;
    }
    GoToTop.prototype.setup = function () {
        this._borderline = 200;
        this._isActive = false;
        this._setNativeEvents();
        this._setWatches();
    };
    GoToTop.prototype.teardown = function () {
        this._clearNativeEvents();
        this._clearWatches();
        delete this._el;
        delete this._borderline;
        delete this._isActive;
        delete this._onClick;
        delete this._onResize;
        delete this._onScroll;
        delete this._unwatchFooterHeight;
    };
    GoToTop.prototype._setWatches = function () {
        var _this = this;
        this._unwatchFooterHeight = store.watch(types.FOOTER_HEIGHT, function () {
            return _this.setPosition();
        });
    };
    GoToTop.prototype._clearWatches = function () {
        this._unwatchFooterHeight();
    };
    GoToTop.prototype._setNativeEvents = function () {
        var _this = this;
        this._onClick = function () {
            TweenLite.killTweensOf(scroller);
            TweenLite.to(scroller, 0.3, {
                scrollTo: 0,
                ease: Sine.easeInOut,
            });
        };
        this._onResize = function () { return _this.setPosition(); };
        this._onScroll = function () {
            _this.activate();
            _this.setPosition();
        };
        this._el.addEventListener(eventTypes.CLICK, this._onClick);
        window.addEventListener(eventTypes.RESIZE, this._onResize);
        scroller.addEventListener(eventTypes.SCROLL, this._onScroll);
    };
    GoToTop.prototype._clearNativeEvents = function () {
        this._el.removeEventListener(eventTypes.CLICK, this._onClick);
        window.removeEventListener(eventTypes.RESIZE, this._onResize);
        scroller.removeEventListener(eventTypes.SCROLL, this._onScroll);
    };
    GoToTop.prototype.activate = function () {
        var scrollTop = scroller.scrollTop;
        if (this._borderline < scrollTop) {
            if (this._isActive) {
                return;
            }
            this._el.classList.add("is-active");
            this._isActive = true;
            return;
        }
        if (!this._isActive) {
            return;
        }
        this._el.classList.remove("is-active");
        this._isActive = false;
    };
    GoToTop.prototype.setPosition = function () {
        var footerHeight = store.state.footerHeight;
        var scrollTop = scroller.scrollTop;
        if (scroller.scrollHeight - footerHeight <=
            scrollTop + document.documentElement.clientHeight) {
            this._el.classList.add("is-abs");
            this._el.style.bottom = footerHeight + "px";
            return;
        }
        this._el.classList.remove("is-abs");
        this._el.style.bottom = "";
    };
    return GoToTop;
}());
export default GoToTop;
